// hooks/campaign/useCampaignData.ts
import { useCustomer, useEntityData, useFormSubmission } from '@/hooks';
import { useModal } from '@/contexts';
import { clearSelectedDateRange } from '@/utils';

export const useCampaignData = () => {
    const { selectedCustomerId, setSelectedCustomerId, customerData, setSelectedDateRange, refreshCustomers } =
        useCustomer();
    const { customerContent, refreshData, loading, hasLoadedOnce } = useEntityData(selectedCustomerId);
    const { closeModal } = useModal();
    const { handleSave } = useFormSubmission(refreshData, closeModal, selectedCustomerId);

    const handleCustomerSelection = (customerId: number) => {
        if (selectedCustomerId === customerId && customerData.length > 0) return;

        setSelectedCustomerId(customerId);
        clearSelectedDateRange();
        setSelectedDateRange?.(null);
    };

    return {
        customerData,
        customerContent: { ...customerContent },
        selectedCustomerId,
        loading,
        hasLoadedOnce,
        setSelectedCustomerId: handleCustomerSelection,
        handleSave,
        handleSaveCampaign: handleSave,
        handleSaveBooking: handleSave,
        handleSaveCreative: handleSave,
        handleSaveImpressionTag: handleSave,
        handleSaveSiteTag: handleSave,
        refreshData,
        refreshCustomers,
    };
};
